import { ButtonHTMLAttributes } from "react";
import classes from './Button2.module.css'

const Button2 = (props:ButtonHTMLAttributes<HTMLButtonElement>) => {
    return ( 
        <button {...props} className={classes.button}>{props.children} </button>
     );
}
 
export default Button2;